import { Button, Container, IconName, Stack, Table, TableHeader, TableProvider, TableState } from '@optimus-web/core';
import { lt, useToggle } from '@mews/framework';
import { RoutingRulesListFilterValues } from '../../schemas/routingRulesListFilterSchema';
import { RoutingRuleListTableData, RoutingRuleListTableRowData } from './types';
import { contentSpacing } from './constants';
import { useRoutingRulesTableColumns } from './utils/useRoutingRulesTableColumns';
import { RoutingRulesTableFilterForm } from './RoutingRulesTableFilterForm';

interface RoutingRulesTableProps {
    data: RoutingRuleListTableData;
    loading: boolean;
    tableState: TableState<RoutingRuleListTableRowData>;
    showTableFilters?: boolean;
    displayLegacy: boolean;
    onTableStateChange: (newState: TableState<RoutingRuleListTableRowData>) => void;
    onFiltersSubmit: (values: RoutingRulesListFilterValues) => void;
}

export const RoutingRulesTable: React.FC<RoutingRulesTableProps> = ({
    data,
    loading,
    tableState,
    showTableFilters,
    displayLegacy,
    onTableStateChange,
    onFiltersSubmit,
}) => {
    const columns = useRoutingRulesTableColumns();
    const [showSidebar, toggleSidebar] = useToggle();

    return (
        <Stack fill spacing={contentSpacing} tabletMax={{ spacing: showSidebar ? '0' : contentSpacing }}>
            <Container overflowY="auto" width="100%" padding={['0', contentSpacing]}>
                <TableProvider columns={columns} state={tableState} onStateChange={onTableStateChange} as="div">
                    <TableHeader
                        title={lt('BillingAutomationPlural')}
                        globalSearch
                        rightSide={
                            showTableFilters ? (
                                <Button icon={IconName.Filter} type="button" size="small" onClick={toggleSidebar}>
                                    {lt('Filter')}
                                </Button>
                            ) : null
                        }
                    />
                    <Table
                        fixedFirstColumn
                        uniqueRowId="id"
                        data={data}
                        amountOfRows={data?.length ?? 0}
                        loading={loading}
                    />
                </TableProvider>
            </Container>

            <RoutingRulesTableFilterForm
                toggle={toggleSidebar}
                show={showSidebar}
                loading={loading}
                hideOffset={contentSpacing}
                title={lt('Filter')}
                displayLegacy={displayLegacy}
                onSubmit={onFiltersSubmit}
            />
        </Stack>
    );
};
